import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { getUserRequestCount } from "../../service/api/UserRequestsService";
import "./Historico.scss";

export const Historico = () => {

    const history = useHistory();

    const [ count, setCount ] = useState({
        requestGrades: 0,
        activeGrades: 0,
        expiredGrades: 0
    });

    useEffect(() => {
        const userCount = getUserRequestCount();
        userCount.then((data) => setCount(data));
    }, [])

    const handleClickHistorico = status => {
        console.log("/request" + (status ? "?filterStatus=" + status : ''));
        history.push("/request" + (status ? "?filterStatus=" + status : ''));
    }

    return (
        <div className="historico">
            <div className="header">
                <h3>Histórico de solicitudes</h3>
            </div>
            <table className="table text-start">
                <tbody>
                    <tr onClick={() => handleClickHistorico(null)}>
                        <td className="w-25">
                            <div className="capsule blue"></div>
                        </td>
                        <td className="w-50 align-middle text-start">
                            eGrade solicitados
                        </td>
                        <td className="w-25 align-middle text-end">
                            {count.requestGrades}
                        </td>
                    </tr>
                    <tr onClick={() => handleClickHistorico("active")}>
                        <td className="w-25">
                            <div className="capsule green"></div>
                        </td>
                        <td className="w-50 align-middle text-start">
                            eGrade en vigor
                        </td>
                        <td className="w-25 align-middle text-end">
                        {count.activeGrades}
                        </td>
                    </tr>
                    <tr onClick={() => handleClickHistorico("expired")}>
                        <td className="w-25"> 
                            <div className="capsule red"></div>
                        </td>
                        <td className="w-50 align-middle text-start">
                            eGrade expirados
                        </td>
                        <td className="w-25 align-middle text-end">
                        {count.expiredGrades}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}